<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Online Outstanding Fees Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                AY ::{{ current_ay }} || Standard :: {{ leaner_std }} || Division :: {{ leaner_div }}
            </v-row>
            <v-data-table :headers="headers" :items="student_outstanding_fees_list" dense class="mytable elevation-1" :search="search">
                
                <template v-slot:item.pay_fee="{ item }">
                    <div v-if="item.balance > 0">
                        <v-text-field class="mt-1 pt-1" @change="checkfee(item.pay_fee, item.balance);gettotal_amt(item)" rounded label="Enter Amount" hide-details="auto" v-model="item.pay_fee" outlined dense></v-text-field>
                    </div>
                    <div v-else class="text">
                        <strong>Already Paid</strong>
                    </div>
                </template>

                <template v-slot:item.action="{ item }">
                    <span class="text" v-if="item.balance > 0">
                        <div v-if="pgs.includes('PayTM')">
                            <form :action="url" @submit="payment" name="paytmform" method="POST">
                                <input type="hidden" :value="item.orgid" name="orgid" />
                                <input type="hidden" :value="item.tenantid" name="tenantid" />
                                <input type="hidden" :value="item.uid" name="uid" />
                                <input type="hidden" :value="item.learner_id" name="studid" />
                                <input type="hidden" :value="item.total_amt" name="fee_amount" />
                                <input type="hidden" :value="item.outstanding_fee_id" name="json_pre_trans_data" />
                                <input type="hidden" :value="item.hash_val" name="hash_val" />
                                <input type="hidden" value="OF" name="p_type" />
                                <!-- json_pre_trans_data -> outstanding_fee.id -->
                                <v-btn small class="button" type="submit" :loading="loader" :disabled="item.pay_fee == 0 || flag_disable">Proceed(PayTM)</v-btn>
                            </form>
                        </div>
                        <div v-if="pgs.includes('BillDesk')">
                            <v-btn small type="button" rounded @click="payWithBillDesk(item)" :disabled="item.pay_fee == 0 || flag_disable" :loading="loader" class="button">
                                Proceed(BillDesk)
                            </v-btn>
                        </div>
                    </span>
                    <span v-else class="text">
                        <strong>Already Paid</strong>
                    </span>
                </template>
                <!-- <template v-slot:item.total_fee="{ item }">
                    {{ item.total_amt}}
                </template> -->
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        props: {
            selected_children: String,
        },
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            get_component_installmet_list: [],
            show: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            flag_disable: false,
            current_ay: "",
            leaner_div: null,
            leaner_std: null,
            search: "",
            s3url: "",
            misc_fees_list: "",
            url: "",
            student_outstanding_fees_list: [],
            payment_modes: [],
            select_mode: "",
            new_input: "",
            student_receipts: [],
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "PRN No.", value: "stud_reg_no", align: "center" },
                { text: "Academic Year", value: "of_academicyear" , align: "center"},
                { text: "Fees", value: "fee", align: "center" },
                { text: "Weekly Fine (If Applicable)", value: "fine", align: "center" },
                { text: "Paid Fees", value: "paid_fee", align: "center" },
                { text: "Balance", value: "balance" , align: "center"},
                { text: "Amount", value: "pay_fee" , align: "center"},
             //   { text: "Total Amount To Pay (Fees + Fine)", value: "total_fee" , align: "center"},
                { text: "Pay", value: "action", align: "center" },
            ],
            billdeskMsg: null,
            pgs: []
        }),
        created() {
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_outstanding";
        },
        methods: {
            gettotal_amt(item){
               item.total_amt = parseFloat(item.total_amt)+parseFloat(item.pay_fee)
            },
            payment() {
                var formData = new FormData(paytmform);
                console.log("formData");
                console.log(formData);
                this.loader = false;
            },
            checkfee(pay_fee, balance) {
                // alert(pay_fee + "----"+balance)
                if (pay_fee > balance) {
                    //   alert("in if")
                    this.showSnackbar("#b71c1c", "Amount should be less than balance amount");
                    this.flag_disable = true;
                    return;
                } else {
                    this.flag_disable = false;
                }
            },
            getDetails() {
                const formData = {
                    registration_no: this.selected_children.registration_number,
                };
                this.overlay = true;
                axios
                    .post("OutstandingFees/getLearnerData", formData)
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.flag == "YES") {
                            this.show = true;
                            this.student_outstanding_fees_list = res.data.array_of_sof;
                            this.payment_modes = res.data.payment_modes;
                            this.student_receipts = res.data.student_receipts;
                            this.current_ay = res.data.current_ay;
                            this.leaner_std = res.data.leaner_std;
                            this.leaner_div = res.data.leaner_div;
                            this.pgs = res.data.pgs
                            this.loader = false;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        this.loader = false;
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                    });
            },
            payWithBillDesk(item) {
                this.overlay = true;

                // let formData = new FormData();
                // formData.append("orgid", item.orgid);
                // formData.append("tenantid", item.tenantid);
                // formData.append("uid", item.uid);
                // formData.append("fee_amount", item.total_amt);
                // formData.append("studid", item.learner_id);
                // formData.append("json_pre_trans_data", item.outstanding_fee_id);
                // formData.append("hash_val", item.hash_val);
                // formData.append("p_type", "OF");
                const formData = {
                    fee_amount: item.total_amt,
                    purpose: 'Outstanding Fees Of - ' + item.of_academicyear,
                    tenantid: item.tenantid,
                    orgid: item.orgid,
                    ay: item.ay,
                    uid: item.uid,
                    studid: item.learner_id,
                    json_pre_trans_data: item.outstanding_fee_id,
                    hash_val: item.hash_val,
                    payment_type: "OUTSTANDING",
                    p_type:"OF"
                }
                axios.post("/paymentGatewayBillDesk/initiateBillDeskPayment",  formData)
                    .then(res => {
                        if (res.data.msg == "200") {
                            this.billdeskMsg = res.data.billdeskMsg
                            this.startBillDesk()
                        } else {
                            this.showSnackbar("red", res.data.msg || "BillDesk init failed")
                        }
                    })

                    .catch(err => {
                        console.error(err);
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                        this.overlay = false;
                    })
            },

            startBillDesk() {
                if (!this.billdeskMsg) {
                    this.showSnackbar("red", "Payment data missing")
                    return
                }

                bdPayment.initialize({
                    msg: this.billdeskMsg,
                    options: {
                        enableChildWindowPosting: true,
                        enablePaymentRetry: true,
                        retry_attempt_count: 2
                    }
                });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            this.getDetails();
        },
    };
</script>

<style scoped>
    .text {
        color: red !important;
    }
</style>
